import { CalendarEventProvider } from '../../../../context/CalendarEventProvider';
import { CalendarEventsContainer } from './CalendarEventsContainer';

export const CalendarEventsPanel = () => {
  return (
    <CalendarEventProvider>
      <CalendarEventsContainer />
    </CalendarEventProvider>
  );
};
